import axios from "axios";

const nodeEnv = process.env.NODE_ENV;
const API_BASE_URL =
  nodeEnv === "production"
    ? "https://service.webpal.chat/api"
    : "http://localhost:3002/api";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl: string | undefined = error.config?.url;
      const isLoginRequest =
        !!requestUrl && requestUrl.includes("/admin/login");
      const isOnLoginPage =
        typeof window !== "undefined" && window.location.pathname === "/login";

      if (!isLoginRequest) {
        localStorage.removeItem("adminToken");
      }

      // Avoid forcing a reload during login failures or when already on the login page
      if (!isLoginRequest && !isOnLoginPage) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
